export default __webpack_public_path__ + "static/media/logs.ca4d1a9f.svg";